import API from '@apis/client';
import axios, { AxiosResponse } from 'axios';
import { CreateCdnUrlPayload } from 'models/Supplement';
import {
  SystemPostPresignedUrlData,
  SystemPostPresignedUrlError,
  SystemPostPresignedUrlPayload,
} from 'models/swagger/data-contracts';

/**
 *  Presigned URL 생성 API
 *  @function createPresignedUrlApi
 *  @param {string} target 업로드 대상
 *  @param {string} ext 파일 확장자
 */
export const createPresignedUrlApi = ({
  target,
  ext,
}: SystemPostPresignedUrlPayload): Promise<AxiosResponse<SystemPostPresignedUrlData, SystemPostPresignedUrlError>> => {
  return API.post(`/system/presigned_url`, { target, ext });
};

/**
 *  CDN URL 생성 API
 *  @function createCdnUrlApi
 */
export const createCdnLinkApi = async ({ url, file }: CreateCdnUrlPayload) => {
  return axios.put(url, file, {
    headers: {
      'Content-Type': file?.type || 'application/octet-stream',
    },
  });
};
